{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "file:///Experiences.json",
  "title": "Experiences",
  "type": "object",
  "properties": {
        "role": { 
          "type": "string",
          "minLength": 1
        },
        "title": { 
          "type": "string",
          "minLength": 1
        },
        "yearsNumber": { 
          "type": "number",
          "minimum": 1
        }
    }
}